export default "__VITE_PUBLIC_ASSET__b18356f2__"